import { get, post } from '@/request';

const daysApi = {
  openList(query) {
    return get('/nfm/days/zlb/openList', query);
  },
  listTimeslot(data) {
    return post('/nfm/timeslot/zlb/list', data);
  }
};
export default daysApi;
